/**
 * "Find your fit" modal.
 *
 * Opens from the size picker and behaves like the quick-add modal: backdrop
 * click, close button and Escape all dismiss it, and focus moves to the close
 * button on open and back to the trigger on close.
 *
 * The table is authored in cm; the INCH view divides by 2.54 on the fly so the
 * metafield only ever holds one set of numbers.
 */
(function () {
  var CM_PER_INCH = 2.54;
  var lastTrigger = null;

  function format(value, unit) {
    var number = parseFloat(String(value).replace(',', '.'));
    if (isNaN(number)) return value;
    if (unit === 'inch') number = number / CM_PER_INCH;
    return (Math.round(number * 10) / 10).toString().replace('.', ',');
  }

  function setUnit(modal, unit) {
    modal.querySelectorAll('[data-candela-unit]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.candelaUnit === unit);
      btn.setAttribute('aria-pressed', btn.dataset.candelaUnit === unit ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-candela-cm]').forEach(function (cell) {
      cell.textContent = format(cell.dataset.candelaCm, unit);
    });
  }

  function open(modal, trigger) {
    lastTrigger = trigger || null;
    // Normalise the cells on open: Liquid prints the raw metafield text, which
    // may use either separator, and only setUnit applies our formatting.
    var active = modal.querySelector('[data-candela-unit].is-active');
    setUnit(modal, active ? active.dataset.candelaUnit : 'cm');
    modal.setAttribute('aria-hidden', 'false');
    if (window.CandelaScrollLock) window.CandelaScrollLock.update();
    var close = modal.querySelector('.candela-size-guide__close');
    if (close) close.focus();
  }

  function close(modal) {
    modal.setAttribute('aria-hidden', 'true');
    if (window.CandelaScrollLock) window.CandelaScrollLock.update();
    if (lastTrigger) lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-candela-size-guide]');
    if (trigger) {
      var modal = document.getElementById('CandelaSizeGuide-' + trigger.dataset.candelaSizeGuide);
      if (modal) open(modal, trigger);
      return;
    }

    var openModal = document.querySelector('.candela-size-guide[aria-hidden="false"]');
    if (!openModal) return;

    if (event.target.closest('.candela-size-guide__close')) {
      close(openModal);
      return;
    }

    var unitBtn = event.target.closest('[data-candela-unit]');
    if (unitBtn) {
      setUnit(openModal, unitBtn.dataset.candelaUnit);
      return;
    }

    if (!event.target.closest('.candela-size-guide__dialog')) close(openModal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openModal = document.querySelector('.candela-size-guide[aria-hidden="false"]');
    if (openModal) close(openModal);
  });
})();
